import React from 'react';
import ScheduleForm from '../../../../../../shared/components/schedule-form/schedule-form';
import { RequestStatus } from '../../../../../../shared/enums/request-status';
import { UpdateScheduleRequestPayload } from '../../../../types/request-payload';
import { IProps } from './types';

const UpdateSchedule: React.FC<IProps> = ({
  schedule,
  schedules,
  timezoneList,
  onDelete,
  updateScheduleRequestStatus,
  sendUpdateScheduleRequest,
}) => {
  const isLoading = updateScheduleRequestStatus === RequestStatus.Pending;

  const existingScheduleNames =
    schedules?.map((s) => s.name) ?? [schedule?.name].filter(Boolean);

  const handleSubmit = (payload: UpdateScheduleRequestPayload) => {
    sendUpdateScheduleRequest(schedule?.id, payload);
  };

  return (
    <ScheduleForm
      mode="edit"
      schedule={schedule}
      existingScheduleNames={existingScheduleNames}
      timezoneList={timezoneList}
      onSubmit={handleSubmit}
      isSubmitLoading={isLoading}
      onDelete={onDelete}
      submitLabel="Save"
      showInlineFooter
    />
  );
};

export default UpdateSchedule;
